import type { BasicSprite } from "../sprites/basic_sprite"

// Center an item sprite inside a square well whose top-left corner is (x, y).
//
// BasicSprite does NOT draw from its own origin, and how far off it is depends on where the art came
// from. An icon out of the packed `humanoid` atlas carries a pivot (anchor ~0.5/0.53), so pixi
// centers it for free. A resource or structure icon -- a chest, a table, a straw bed -- is a
// `tileset:tileId` frame out of a map-tile atlas instead, and those atlases carry no pivot at all;
// BasicSprite compensates by shifting the sprite half a texture width left and a flat 14px up. That
// shift is in UNSCALED texture pixels and tuned for the world, where tile art draws at roughly 1:1
// and wants to sit on its cell. At a slot's reduced scale it over-corrects, dragging the art up and
// to the left -- hard enough to pin it against the corner of a 32px docked slot.
//
// Measuring what the sprite actually draws covers both origins, and any future third one.
//
// Type-only import of BasicSprite on purpose: this keeps the module free of the sprite/renderer
// import cycle, so it can be exercised on its own.
export const centerSpriteIn = (sprite: BasicSprite, x: number, y: number, size: number) => {
    const b = sprite.getLocalBounds()
    if (b.width > 0 && b.height > 0) {
        sprite.x = x + size / 2 - (b.x + b.width / 2)
        sprite.y = y + size / 2 - (b.y + b.height / 2)
    } else {
        sprite.x = x + size / 2
        sprite.y = y + size / 2
    }
}
